import {
  Box,
  Card,
  Container,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { websiteTitle } from 'src/config';
import { makeStyles } from 'tss-react/mui';
import SOCReportTable from './SOCReportTable';
import useAuth from 'src/hooks/useAuth';

const useStyles = makeStyles()(theme => ({
  metalRoot: {
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing(4)} ${theme.spacing(0.5)}`
    }
  }
}));

const SOCReportView = props => {
  const { t } = useTranslation();
  const { loggedInUser } = useAuth();
  const manageUsersPermissionOrAdmin =
    loggedInUser?.groups?.filter(group => !!group.userRole.manageUsers)
      ?.length > 0 || loggedInUser.adminRole.adminRead;
  const { classes } = useStyles();
  const theme = useTheme();
  const pageTitle = websiteTitle + ' - ' + t('socReport');
  const mediumDevice = useMediaQuery(theme.breakpoints.down('md'));
  const smallDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page className={classes.metalRoot} title={pageTitle}>
      <Container
        maxWidth="xxl"
        style={mediumDevice ? { padding: '0 8px' } : {}}
      >
        <Box
          py={3}
          px={2}
          sx={{ backgroundColor: 'var(--neutral-2)', borderRadius: '4px' }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'var(--color-text)',
              padding: mediumDevice ? '0rem 1rem' : 0
            }}
          >
            Please be reminded that the SOC report and the information provided
            are sensitive and must be treated as confidential.
          </Typography>
        </Box>
        {mediumDevice && !manageUsersPermissionOrAdmin && (
          <Typography
            variant="body2"
            sx={{
              mb: '1.5rem',
              color: 'var(--color-text)',
              padding: '0rem 1rem',
              fontWeight: 'bold'
            }}
          >
            Group Owner access is required to download SOC reports.
          </Typography>
        )}
        <SOCReportTable
          downloadReportsPermission={manageUsersPermissionOrAdmin}
        />
      </Container>
    </Page>
  );
};

export default SOCReportView;
